const prepareRegistrationValuesToSave = ({
    _fields,
    incomingValues,
    commitmentDetails,
}) => {
    const values = { ...incomingValues };
    const allCustomFieldValues = [];
    const displayedCustomFields = [];
    // Determine which fields are displayed & that should be sent with values
    _fields.forEach((field) => {
        const { id } = field;
        displayedCustomFields.push(`Custom_Fields_${id}`);
    });
    // Find the keys for all the Custom Fields
    Object.keys(values).forEach((value) => {
        if (value.indexOf("Custom_Fields") === 0) {
            allCustomFieldValues.push(value);
        }
    });
    // Compare and pull out only the keys that were not displayed
    // and should not be sent with values
    const valuesToRemove = allCustomFieldValues.filter(
        (x) => displayedCustomFields.indexOf(x) === -1,
    );
    // Delete each key that should not be there
    if (valuesToRemove) {
        valuesToRemove.forEach((value) => {
            delete values[value];
        });
    }

    if (values.Add_New_Registration) {
        delete values.Add_New_Registration;
    }

    // check if the current selected category requires a commitment
    // if so add the commitment details to the values object.
    // we only want to add this if event level and category level enableCommitments are both true
    if (values.Category.length) {
        const categoryId = values.Category[0];
        if (
            commitmentDetails[categoryId].amount > 0 &&
            commitmentDetails[categoryId].enabled
        ) {
            values.Commitment = {
                amount: commitmentDetails[categoryId].amount,
                deadline: commitmentDetails[categoryId].deadline,
            };
        } else {
            values.Commitment = {
                amount: 0,
                deadline: "",
            };
        }
    }

    // Set a flag to indicate whether the entire reg page has been saved or
    // if values are preset and should be cleared on cancel
    values.Has_Been_Saved = true;

    // Set a flag that confirms the registration.
    // If a registration exists without this value, we know that the user
    // has not checked the pre-filled data and confirmed that registration.
    values.Needs_To_Be_Reviewed = false;
    return values;
};

export default prepareRegistrationValuesToSave;
